
<app-header *ngIf="loginRequired" ></app-header>
  
<div class="container"> 
    <div class="row"> 
      <!--Seccion 1 ZKPUS-96-->
      <div class="row"> 
          <div class="col-lg-7">
              <div class="row">
                  <div class="row container text-center">
                      <h2>Dispositivos</h2>
                  </div>
              </div> 
              <br />
              <div class="row">
                
                  <div class="row">
                      <dx-data-grid #grid
                                    id="gridContainer" class="table table-hover"
                                    [dataSource]="dataSource"
                                    [showBorders]="true"
                                    [remoteOperations]="true" 
                                    (onCellClick)="onCellClick($event)"> 
                          <dxo-selection mode="single"></dxo-selection>
                          <dxo-paging [pageSize]="5"></dxo-paging>
                          <dxo-pager [showPageSizeSelector]="true"
                                     [allowedPageSizes]="[5, 10, 20]"
                                     [showInfo]="true">
                          </dxo-pager> 
                          <dxo-header-filter [visible]="true"></dxo-header-filter>
                          <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
                          <dxi-column dataField="id" caption="Id" [visible]="false"></dxi-column>
                          <dxi-column dataField="deviceName" caption="Nombre"></dxi-column>
                          <dxi-column dataField="deviceSN" caption="SN"></dxi-column>
                          <dxi-column dataField="ipAddress" caption="IP"></dxi-column>
                          <dxi-column dataField="lastActivity" type="date"
                                displayFormat="d/MM/yyyy" caption="Conexión"
                                ></dxi-column>
                          <dxi-column dataField="state" caption="Estatus" with="25px"></dxi-column>
    
                      </dx-data-grid>
                  </div>
              </div>
          </div>
          <!--Seccion 2 ZKPUS-97-->
          <div class="col-lg-5">
                <div class="container">
                        <dx-chart id="chart" title="Dispositivos" [dataSource]="populationDevices">
                            <dxi-series valueField="SL" name="SL"></dxi-series>
                            <dxi-series valueField="OffLine" name="OffLine"></dxi-series>
                            <dxi-series valueField="connecting" name="Connecting / Connection"></dxi-series>
                            <dxi-series valueField="Online" name="Online"></dxi-series>
                            <dxo-common-series-settings argumentField="status" type="bar"></dxo-common-series-settings>
                            <dxo-legend [visible]="true"></dxo-legend>
                            <dxo-argument-axis [tickInterval]="10" >
                                <dxo-label>
                                    <dxo-format type="decimal"></dxo-format>
                                </dxo-label>
                            </dxo-argument-axis>
                        </dx-chart>
                 </div>
          </div>
      </div>
    
      <!--Seccion  3 ZKPUS-98-->
      <div class="row">
          <home-record></home-record>       
      </div>
    
    </div> 
  
</div>

<app-footer></app-footer>